import axios from "axios";
import { Base_URL } from "../url";

export const saveHouseBankDetails = async (houseBankData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/HouseBank/CreateHouseBank?UserName=${userName}`,
      houseBankData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving house bank details!";
  }
};

export const getAllHouseBanks = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/HouseBank/GetAllHouseBanks/id?id=${id}`);
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching house banks!";
  }
};
